<template>
  <div
    class="configurator-layer-editor-modal-toolbar-toogle-item"
    :class="`configurator-layer-editor-modal-toolbar-toogle-item--${modifier}`"
  >
    <input
      :id="localId"
      v-model="localValue"
      type="checkbox"
      :name="name"
      class="configurator-layer-editor-modal-toolbar-toogle-item__input"
    />
    <label
      :for="localId"
      :title="title || label"
      class="configurator-layer-editor-modal-toolbar-toogle-item__label"
    >
      <slot name="label">
        <span
          class="configurator-layer-editor-modal-toolbar-toogle-item__label-inner"
        >
          <slot>{{ label }}</slot>
        </span>
      </slot>
    </label>
  </div>
</template>

<script>
import { randomStr } from '../../../../utils/String';

export default {
  name: 'ConfiguratorLayerEditorModalToolbarToogleItem',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
    },
    label: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    id: {
      type: String,
      default: undefined,
    },
    modifier: {
      type: String,
      required: true,
    },
  },
  computed: {
    localId() {
      return this.id || `toggle-item--${randomStr()}`;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('change', v);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-layer-editor-modal-toolbar-toogle-item {
  $block-selector: &;
  $configurator-layer-editor-modal-toolbar-toggle-item-label-min-width: $configurator-zone-input-height;

  &__input {
    @include sr-only();
  }

  &__label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: $configurator-layer-editor-modal-toolbar-toggle-item-label-min-width;
    min-height: $configurator-layer-editor-modal-toolbar-toggle-item-label-min-width;
    padding: 0.5em;
    cursor: pointer;
    transition-property: background-color, color;
    transition-duration: $default-transition-duration;

    #{$block-selector}__input:checked + & {
      background-color: $color-blue-malibu;
      color: white;
    }

    &::before {
      font-family: 'Times New Roman', serif;
      line-height: 1;
      font-size: 1.5em;

      #{$block-selector}--bold & {
        content: 'G';
        font-weight: bold;
      }

      #{$block-selector}--italic & {
        content: 'I';
        font-style: italic;
      }

      #{$block-selector}--underlined & {
        content: 'S';
        text-decoration: underline;
      }
    }
  }

  &__label-inner {
    @include sr-only();
  }
}
</style>
